
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton, AppSelect } from '@/components';
import { useRfmPersona } from '@/modules/rfm/persona/model/edit';
import { ROUTE_NAME_RFM } from '@/modules/rfm/router';

export default defineComponent({
    name: ROUTE_NAME_RFM.PERSONA.EDIT,
    components: { AppFormRow, AppInput, AppCard, AppButton, AppSelect },
    setup() {
        const { model, v$, fetch, fetchRfmGroupAll, rfmGroupOptions, actions } = useRfmPersona();

        onMounted(async () => {
            await fetchRfmGroupAll();
            await fetch();
        });

        return { v$, model, rfmGroupOptions, actions };
    }
});
